import callApi from "../api/PuorkServer";

export async function getSummary () {
    const response = await callApi('/company/summary');
    return response;
}